import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import Review from '../../molecules/Review';
import ItemCollection from '../ItemCollection';
var Reviews = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Reviews, _React$PureComponent);
  var _super = _createSuper(Reviews);
  function Reviews() {
    _classCallCheck(this, Reviews);
    return _super.apply(this, arguments);
  }
  _createClass(Reviews, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        reviews = _this$props.reviews,
        header = _this$props.header,
        itemsPerRow = _this$props.itemsPerRow,
        itemsDivided = _this$props.itemsDivided,
        centerHeader = _this$props.centerHeader,
        onlyEvenRows = _this$props.onlyEvenRows,
        as = _this$props.as,
        cardInlinePhoto = _this$props.cardInlinePhoto,
        imageCircular = _this$props.imageCircular,
        imageSize = _this$props.imageSize,
        showImage = _this$props.showImage,
        itemButtonFloat = _this$props.itemButtonFloat,
        itemCenterContent = _this$props.itemCenterContent,
        linkAs = _this$props.linkAs,
        verticalItemAlign = _this$props.verticalItemAlign;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemCollection, {
        header: header,
        collectionType: as === 'horizontalItem' ? 'items' : 'custom',
        itemsPerRow: itemsPerRow,
        itemsDivided: itemsDivided,
        centerHeader: centerHeader,
        onlyEvenRows: onlyEvenRows,
        className: "reviews"
      }, reviews.map(function (review) {
        return /*#__PURE__*/React.createElement(Review, _extends({}, review, {
          key: review.author,
          image: showImage && review.image,
          as: as,
          cardInlinePhoto: cardInlinePhoto,
          imageCircular: imageCircular,
          imageSize: imageSize,
          itemButtonFloat: itemButtonFloat,
          itemCenterContent: itemCenterContent,
          linkAs: linkAs,
          verticalItemAlign: verticalItemAlign
        }));
      })));
    }
  }]);
  return Reviews;
}(React.PureComponent);
export { Reviews as default };
Reviews.defaultProps = {
  header: 'Reviews',
  as: 'horizontalItem',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  imageCircular: false,
  imageSize: 'small',
  showImage: true,
  itemButtonFloat: 'left',
  itemCenterContent: false,
  linkAs: 'none',
  itemsPerRow: 3,
  itemsDivided: false,
  centerHeader: false,
  onlyEvenRows: false,
  verticalItemAlign: 'center'
};
Reviews.propOptions = {};
Reviews.dataPropsMap = {
  reviews: ['business', 'reviews']
};